import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dvds-and-blurays',
  templateUrl: './dvds-and-blurays.component.html',
  styleUrls: ['./dvds-and-blurays.component.css']
})
export class DvdsAndBluraysComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
